import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AuthEntity } from '_entities';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const { getTimeZone, getUserState } = AuthEntity.selectors;

const AccountTime = ({ showState }) => {
  const timeZone = useSelector(getTimeZone);
  const accountState = useSelector(getUserState);
  const [currentTime, setCurrentTime] = useState('');

  useEffect(() => {
    if (!timeZone) return undefined;

    const updateTime = () => {
      const now = new Date();
      const formatted = now.toLocaleTimeString('en-US', {
        timeZone,
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
      setCurrentTime(formatted);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [timeZone]);

  if (!timeZone || !currentTime) return null;

  return <Styled.TimeContainer>{`${showState ? accountState : ''} time ${currentTime}`}</Styled.TimeContainer>;
};

AccountTime.propTypes = {
  showState: PropTypes.bool,
};

AccountTime.defaultProps = {
  showState: false,
};

export default AccountTime;
